import { useState } from 'react';
import axios from 'axios';
import BASE_URL from '../../config';

const useAddToCart = (onMessage = null) => {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [loginMessage, setLoginMessage] = useState(null);

  const handleAddToCart = async (slug, quantity, fetchCart = null) => {
    setLoading(true);
    setError(null);
    setSuccess(false);
    setLoginMessage(null);

    const authToken = localStorage.getItem('authToken');

    // If user is not logged in
    if (!authToken) {
      const loginMsg = "Bitte melden Sie sich an, um Produkte in den Warenkorb zu legen.";
      setLoginMessage(loginMsg);
      if (onMessage) onMessage(loginMsg);

      setTimeout(() => {
        window.location.href = "/login";
      }, 2000);
      setLoading(false);
      return;
    }

    const headers = {
      'Content-Type': 'application/json',
      Authorization: `Token ${authToken}`,
    };

    try {
      await axios.post(
        `${BASE_URL}/api/add-to-cart/`,
        { slug, quantity },
        { headers }
      );

      setSuccess(true);

      if (fetchCart) {
        await fetchCart(); // Refresh cart data and wait for it
      }
    } catch (err) {
      console.error('Error adding to cart:', err);
      const backendMessage =
        err.response?.data?.error || 'Artikel konnte nicht zum Warenkorb hinzugefügt werden';

      setError(backendMessage);
      if (onMessage) onMessage(backendMessage);
    } finally {
      setLoading(false);
    }
  };

  return {
    handleAddToCart,
    loading,
    error,
    success,
    loginMessage,
  };
};

export default useAddToCart;
